(()=>{
function init(scope=document){
 scope.querySelectorAll('[data-nm-product]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('.nm-product-form'), select=root.querySelector('[data-nm-variant]'),qty=form.querySelector('[name="quantity"]'),add=root.querySelector('[data-nm-add]'),status=root.querySelector('[data-nm-status]'),sticky=root.querySelector('[data-nm-sticky]'),stickyAdd=root.querySelector('[data-nm-sticky-add]'),strings=JSON.parse(root.querySelector('[data-nm-strings]').textContent);
 let busy=false;
 const sync=()=>{const option=select.selectedOptions[0],available=option.dataset.available==='true';root.querySelectorAll('[data-nm-price],[data-nm-button-price],[data-nm-sticky-price]').forEach(el=>el.textContent=option.dataset.price);add.disabled=!available||busy;stickyAdd.disabled=!available||busy;add.querySelector('span').textContent=available?strings.add:strings.soldOut;stickyAdd.textContent=available?strings.add:strings.soldOut;const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);};
 select.addEventListener('change',sync);
 root.querySelector('[data-nm-minus]').addEventListener('click',()=>{qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1);qty.dispatchEvent(new Event('change',{bubbles:true}));});
 root.querySelector('[data-nm-plus]').addEventListener('click',()=>{qty.value=(parseInt(qty.value,10)||1)+1;qty.dispatchEvent(new Event('change',{bubbles:true}));});
 form.addEventListener('submit',async event=>{
 if(event.submitter?.name==='checkout')return;
 event.preventDefault();if(busy||!form.reportValidity())return;busy=true;add.disabled=true;stickyAdd.disabled=true;add.querySelector('span').textContent=strings.adding;status.textContent='';
 try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||strings.error);status.textContent=strings.added;root.querySelector('.nm-cart-success').hidden=false;const cartResponse=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-nm-cart-count]').forEach(el=>el.textContent=cart.item_count);}window.location.assign((window.Shopify?.routes?.root||'/')+'cart');}
 catch(error){status.textContent=error.message||strings.error;}
 finally{busy=false;sync();}
 });
 if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>window.innerHeight;},{threshold:0});observer.observe(add);}
 });
 document.querySelectorAll('[data-nm-menu-dialog]').forEach(dialog=>{
  if(dialog.dataset.ready)return;dialog.dataset.ready='true';
  const toggle=document.querySelector(`[aria-controls="${dialog.id}"]`),close=dialog.querySelector('[data-nm-menu-close]');
  if(!toggle||typeof dialog.showModal!=='function')return;
  toggle.hidden=false;
  toggle.addEventListener('click',()=>{dialog.showModal();toggle.setAttribute('aria-expanded','true');document.body.classList.add('nm-nav-open');close.focus();});
  close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('keydown',event=>{
   if(event.key!=='Tab')return;
   const controls=Array.from(dialog.querySelectorAll('a[href],button:not([disabled])'));
   const first=controls[0],last=controls[controls.length-1];
   if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
   else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{toggle.setAttribute('aria-expanded','false');document.body.classList.remove('nm-nav-open');toggle.focus({preventScroll:true});});
  dialog.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>dialog.close()));
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();

(()=>{
 function start(){
  if(!document.body.classList.contains('nm-store'))return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const desktop=matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const seen=new WeakSet(),animations=new Map(),visible=new Set();
  const progress=document.createElement('div');progress.className='nm-scroll-progress';progress.setAttribute('aria-hidden','true');document.body.append(progress);
  const nav=document.querySelector('[data-nm-shop-scroll]');
  let motionImages=[],roots=[],links=[],navPositions=[],footerTop=Infinity;
  let frame=0,layoutDirty=true,scrollMax=0,height=innerHeight,active=-1;
  const richMotion=()=>desktop.matches&&!reduced.matches&&!window.Shopify?.designMode;
  const remember=(el,animation)=>{
   animations.set(animation,el);
   animation.onfinish=animation.oncancel=()=>animations.delete(animation);
  };
  const reveal='IntersectionObserver'in window?new IntersectionObserver(entries=>{
   entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    const el=entry.target;reveal.unobserve(el);seen.add(el);
    if(reduced.matches||window.Shopify?.designMode||el.contains(document.activeElement))return;
    if(el.matches('.nm-pairs__images,.nm-set-images')){
     if(!richMotion())return;
     const images=Array.from(el.querySelectorAll('img'));
     images.forEach((image,index)=>{
      if(!image.animate)return;
      const side=index-(images.length-1)/2;
      remember(el,image.animate([{transform:`translate3d(${side*16}px,8px,0)`,opacity:.85},{transform:'none',opacity:1}],{duration:450,delay:index*45,easing:'cubic-bezier(.2,.7,.2,1)',fill:'none'}));
     });
    }else if(el.animate){
     const frames=richMotion()?[{opacity:.8,transform:'translateY(12px)'},{opacity:1,transform:'none'}]:[{opacity:.85},{opacity:1}];
     remember(el,el.animate(frames,{duration:richMotion()?400:180,easing:'ease-out',fill:'none'}));
    }
   });
  },{threshold:.08}):null;
  const track='IntersectionObserver'in window?new IntersectionObserver(entries=>{
   entries.forEach(entry=>{if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target);});
   schedule();
  },{rootMargin:'80px 0px'}):null;
  const measure=(y)=>{
   height=innerHeight;scrollMax=Math.max(0,document.documentElement.scrollHeight-height);
   navPositions=roots.map(el=>{const r=el.getBoundingClientRect();return{top:r.top+y,bottom:r.bottom+y};});
   const footer=document.querySelector('.nm-footer');footerTop=footer?footer.getBoundingClientRect().top+y:Infinity;
   layoutDirty=false;
  };
  const paint=()=>{
   frame=0;const y=Math.max(0,scrollY);
   if(layoutDirty)measure(y);
   const positions=richMotion()?Array.from(visible,el=>({el,rect:el.parentElement.getBoundingClientRect()})):[];
   const scrolled=y>40;
   if(document.body.classList.contains('nm-has-scrolled')!==scrolled)document.body.classList.toggle('nm-has-scrolled',scrolled);
   if(!reduced.matches)progress.style.transform=`scaleX(${scrollMax?Math.min(1,y/scrollMax):0})`;
   positions.forEach(({el,rect})=>{
    if(rect.bottom<0||rect.top>height)return;
    if(el.classList.contains('nm-scroll-photo')){
     const phase=Math.min(1,Math.max(0,(height-rect.top)/(height+rect.height)));
     el.style.setProperty('--nm-photo-drift',`${((phase-.5)*16).toFixed(2)}px`);
     el.style.setProperty('--nm-photo-scale',(1.045-phase*.025).toFixed(3));
    }else{
     const distance=Math.min(12,Math.max(-12,(height/2-rect.top-rect.height/2)*.045));
     el.style.setProperty('--nm-drift',`${distance.toFixed(2)}px`);
    }
   });
   if(!nav||navPositions.length!==3)return;
   const hide=!(navPositions[0].bottom-y<150&&footerTop-y>height*.5)&&!nav.contains(document.activeElement);
   if(nav.hidden!==hide)nav.hidden=hide;
   let next=0;navPositions.forEach((position,index)=>{if(position.top-y<=160)next=index;});
   if(next!==active){active=next;links.forEach((link,index)=>{if(index===active)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});}
  };
  function schedule(){if(!frame)frame=requestAnimationFrame(paint);}
  function invalidate(){layoutDirty=true;schedule();}
  const scan=()=>{
   track?.disconnect();visible.clear();
   motionImages.forEach(el=>{el.classList.remove('nm-scroll-image','nm-scroll-photo');['--nm-drift','--nm-photo-drift','--nm-photo-scale'].forEach(key=>el.style.removeProperty(key));});
   motionImages=[];
   if(richMotion()){
    const images=Array.from(document.querySelectorAll('.nm-hero-visual picture,.nm-lifestyle-pair figure > div > .nm-crop,.nm-lifestyle-pair figure > div > .nm-photo,.nm-story-photo > .nm-crop,.nm-story-photo > .nm-photo'));
    const photos=Array.from(document.querySelectorAll('.nm-shop-mosaic__photo img,.nm-lifestyle-slots figure img'));
    images.forEach(el=>el.classList.add('nm-scroll-image'));photos.forEach(el=>el.classList.add('nm-scroll-photo'));
    motionImages=[...images,...photos];motionImages.forEach(el=>track?.observe(el));
   }
   reveal?.disconnect();
   document.querySelectorAll('.nm-shop-mosaic__photo,.nm-lifestyle-slots figure,.nm-pairs__images,.nm-set-images').forEach(el=>{
    if(!seen.has(el)&&reveal&&!reduced.matches&&!window.Shopify?.designMode){
     if(el.getBoundingClientRect().top>innerHeight)reveal.observe(el);else seen.add(el);
    }
   });
   if(nav){
    roots=[document.querySelector('.nm-selection'),document.querySelector('[data-nm-pairs]'),document.querySelector('[data-nm-set]')];
    links=Array.from(nav.querySelectorAll('a'));
    if(roots.some(el=>!el)||links.length!==3){roots=[];nav.hidden=true;}
    else roots.forEach((el,index)=>{if(!el.id)el.id=['nm-shop-oils','nm-shop-pairs','nm-shop-set'][index];links[index].setAttribute('href','#'+el.id);});
    active=-1;
   }
   invalidate();
  };
  const reset=()=>{animations.forEach(animation=>animation.cancel());animations.clear();scan();};
  document.addEventListener('focusin',event=>{animations.forEach((el,animation)=>{if(el.contains(event.target))animation.cancel();});if(nav?.contains(event.target))schedule();});
  nav?.addEventListener('focusout',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',invalidate,{passive:true});window.addEventListener('pageshow',invalidate);
  reduced.addEventListener('change',reset);desktop.addEventListener('change',reset);
  document.addEventListener('shopify:section:load',scan);document.addEventListener('shopify:section:unload',reset);
  if('ResizeObserver'in window)new ResizeObserver(invalidate).observe(document.body);
  document.fonts?.ready.then(invalidate);
  document.addEventListener('load',event=>{if(event.target.tagName==='IMG')invalidate();},true);
  document.body.classList.remove('nm-header-away');
  scan();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

(()=>{
 const videos=new Set();
 const pauseOffscreen='IntersectionObserver'in window?new IntersectionObserver(entries=>{
  entries.forEach(entry=>{if(!entry.isIntersecting&&!entry.target.paused)entry.target.pause();});
 },{threshold:0}):null;
 function initVideos(scope=document){
  scope.querySelectorAll('[data-nm-video] video,.nm-proof-videos video').forEach(video=>{
   if(videos.has(video))return;videos.add(video);pauseOffscreen?.observe(video);
   const root=video.closest('[data-nm-video]'),status=root?.querySelector('.nm-video-status');
   video.addEventListener('play',()=>{if(status)status.textContent='';videos.forEach(other=>{if(other!==video&&!other.paused)other.pause();});});
   video.addEventListener('error',()=>{if(status)status.textContent=root.dataset.error;});
   video.addEventListener('loadeddata',()=>{if(status)status.textContent='';});
  });
 }
 document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(video=>video.pause());});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initVideos());else initVideos();
 document.addEventListener('shopify:section:load',event=>initVideos(event.target));
 document.addEventListener('shopify:section:unload',event=>{videos.forEach(video=>{if(event.target.contains(video)){video.pause();pauseOffscreen?.unobserve(video);videos.delete(video);}});});
})();
